// Warnings printed across the entire bottom of each item's row.
// These are things like messages about coupon being not valid for this item.
import React from "react";
import {isEmpty,camelCase} from "lodash";
import clsx from "clsx";

export default function CartItemWarnings({shoppingCart, item = {}}) {
  let {promotions = {}} = item;
  let warnings = [...(item.warnings || [])];

  if (isEmpty(warnings)) {
    return null;
  }



  return <>
    {warnings.map((w, i) => <CartItemWarning key={i} warning={w} />)}
  </>
}

const MESSAGE_CLASSES = {
  noneAllowed: 'text-gray-600',
  maxDiscount: 'text-gray-600',
  salePromo: 'uppercase text-brand-orange font-bold',
  default: 'text-gray-600'
}

function CartItemWarning({warning}) {
  if (!warning) return null;

  const message = warning.message ? warning.message : warning.toString();
  const flavour = camelCase(warning.flavour || 'default');

  // flavours: max_discount none_allowed
  const className = clsx([
    "text-sm p-2",
    MESSAGE_CLASSES[flavour] || MESSAGE_CLASSES.default
  ]);

  return <div className={className}>{message}</div>
}
